import { AccountUserDto } from '../../../../../shared/models/AccountModel';
import emptySliceApi from '../../../../../shared/store/emptyApiSlice';
import { AdministratorUserApiModel } from '../models';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    removeAdminInvite: builder.mutation<
      AdministratorUserApiModel,
      { accountId: string; inviteId: string }
    >({
      query: ({ accountId, inviteId }) => ({
        url: `v4/accounts/${accountId}/invites/${inviteId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Admin'],
    }),
    removeAdmin: builder.mutation<
      AdministratorUserApiModel,
      { accountId: string; adminId: number }
    >({
      query: ({ accountId, adminId }) => ({
        url: `v4/accounts/${accountId}/admins/${adminId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Admin'],
    }),
    getAdmin: builder.query<
      AccountUserDto,
      { accountId: string; adminId: number }
    >({
      query: ({ accountId, adminId }) =>
        `v4/accounts/${accountId}/admins/${adminId}`,
      providesTags: ['Admin'],
    }),
  }),
});

export const {
  useRemoveAdminInviteMutation,
  useRemoveAdminMutation,
  useGetAdminQuery,
} = apiSlice;
